import { defineCoach } from '../../types';

/** C02: observes the person’s real workflow; navigation is read-only and mutations belong to the page. Arabic copy is DRAFT. */
export const C02 = defineCoach({
  id: 'C02',
  version: 1,
  portal: 'tenant',
  titleKey: 'guidance.coaches.C02.title',
  summaryKey: 'guidance.coaches.C02.summary',
  eligible: (ctx) => ctx.portal === 'tenant' && ctx.canReach('approvals'),
  steps: [
    {
      id: 'c02-welcome',
      kind: 'explain',
      page: 'tenant.approvals',
      anchor: null,
      titleKey: 'guidance.coaches.C02.welcome.title',
      bodyKey: 'guidance.coaches.C02.welcome.body',
      route: 'tenant.approvals',
    },
    {
      id: 'c02-open',
      kind: 'await',
      page: 'tenant.approvals',
      anchor: 'tenant.approvals.inbox',
      titleKey: 'guidance.coaches.C02.open.title',
      bodyKey: 'guidance.coaches.C02.open.body',
      until: {
        route: 'tenant.approval',
      },
    },
    {
      id: 'c02-lines',
      kind: 'explain',
      page: 'tenant.approval',
      anchor: 'tenant.approval.lines',
      titleKey: 'guidance.coaches.C02.lines.title',
      bodyKey: 'guidance.coaches.C02.lines.body',
    },
    {
      id: 'c02-budget',
      kind: 'explain',
      page: 'tenant.approval',
      anchor: 'tenant.approval.budget',
      titleKey: 'guidance.coaches.C02.budget.title',
      bodyKey: 'guidance.coaches.C02.budget.body',
    },
    {
      id: 'c02-policy',
      kind: 'explain',
      page: 'tenant.approval',
      anchor: 'tenant.approval.why',
      titleKey: 'guidance.coaches.C02.policy.title',
      bodyKey: 'guidance.coaches.C02.policy.body',
    },
    {
      id: 'c02-decide-handoff',
      kind: 'handoff',
      page: 'tenant.approval',
      anchor: ['tenant.approval.decision-panel', 'tenant.approval.decide-phone'],
      titleKey: 'guidance.coaches.C02.decide-handoff.title',
      bodyKey: 'guidance.coaches.C02.decide-handoff.body',
      consequenceKey: 'guidance.coaches.C02.decide-handoff.consequence',
    },
    {
      id: 'c02-decide',
      kind: 'await',
      page: 'tenant.approval',
      anchor: ['tenant.approval.decision-panel', 'tenant.approval.decide-phone'],
      titleKey: 'guidance.coaches.C02.decide.title',
      bodyKey: 'guidance.coaches.C02.decide.body',
      until: {
        outcome: 'approval.decided',
        route: 'tenant.approval',
        probe: {
          anchor: 'tenant.approval.result',
          in: [
            'pending_approval',
            'approved',
            'returned',
            'rejected',
            'procurement_review',
            'sourcing_required',
          ],
        },
      },
    },
    {
      id: 'c02-result',
      kind: 'explain',
      page: 'tenant.approval',
      anchor: 'tenant.approval.result',
      titleKey: 'guidance.coaches.C02.result.title',
      bodyKey: 'guidance.coaches.C02.result.body',
    },
    {
      id: 'c02-finish',
      kind: 'finish',
      page: 'tenant.approval',
      anchor: null,
      titleKey: 'guidance.coaches.C02.finish.title',
      bodyKey: 'guidance.coaches.C02.finish.body',
    },
  ],
});
